import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ThresholdValue } from "@/features/deployment-settings/model/admin-settings";

interface ThresholdValueDisplayProps {
  threshold: ThresholdValue;
}

export function ThresholdValueDisplay({ threshold }: ThresholdValueDisplayProps) {
  return (
    <Box sx={{ minHeight: 40, display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        {threshold.value === "" ? "Not configured" : threshold.value}
      </Typography>
    </Box>
  );
}
